<template>
  <section class="mothly-view-calc monthly-split-view show">
    <!-- <div class="small-month-header">
      <a href="#" @click.stop.prevent="goToMonthly">{{
        months[currentMonth - 1]
      }}</a> 
    </div>    we can use same from header-->
    <transition :name="currentSlide" mode="out-in">
      <table
        :key="currentMonth"
        @touchstart="touchStarted"
        @mousedown="touchStartedMouse"
        @touchend="touchEnded"
        @mouseup="touchEndedMouse"
        class="table-condensed day-view-head table-bordered table-striped layout-fixed"
      >
        <thead class="head">
          <tr>
            <th>S</th>
            <th>M</th>
            <th>T</th>
            <th>W</th>
            <th>T</th>
            <th>F</th>
            <th>S</th>
          </tr>
        </thead>
        <tbody class="noselect">
          <week-vue
            :current-month="currentMonth"
            :current-year="currentYear"
            :start-date="1"
            :fetch-appointment-details="true"
            :mark-day="'selectedDay'"
          />
          <week-vue
            v-for="start in startDaysOfWeek"
            :key="start"
            :current-month="currentMonth"
            :current-year="currentYear"
            :start-date="start"
            :fetch-appointment-details="true"
            :mark-day="'selectedDay'"
          />
        </tbody>
      </table>
    </transition>
  </section>
</template>

<script>
import WeekVue from "../Monthly/Week.vue";
import { mapMutations, mapActions } from "vuex";
import { yearlyMonthlyMonthMixin } from "../../../mixins/yearlyMonthlyMonthMixin.js";
import { monthAndWeekMixin } from "../../../mixins/monthAndWeekMixin.js";

export default {
  mixins: [monthAndWeekMixin, yearlyMonthlyMonthMixin],
  data() {
    return {
      currentSlide: "slide-right",
      xStart: 0
    };
  },
  components: {
    WeekVue
  },
  methods: {
    ...mapMutations({
      setWeek: "setWeek",
      setWeekMonth: "setWeekMonth",
      setWeekYear: "setWeekYear",
      setYear: "setYear",
      setMonth: "setMonth"
    }),
    ...mapActions({
      getYearlyAppointments: "getYearlyAppointments"
    }),
    touchStarted(event) {
      this.xStart = event.changedTouches[0].screenX;
    },
    touchEnded(event) {
      const diff = event.changedTouches[0].screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous week
        this.decreaseMonth();
      } else if (Math.abs(diff) > 100 && diff < 0) {
        // Go to next week
        this.increaseMonth();
      }
    },
    touchStartedMouse(event) {
      this.xStart = event.screenX;
    },
    touchEndedMouse(event) {
      const diff = event.screenX - this.xStart;
      if (Math.abs(diff) > 100 && diff > 0) {
        // Go to previous week
        this.decreaseMonth();
      } else if (Math.abs(diff) > 100 && diff < 0) {
        // Go to next week
        this.increaseMonth();
      }
    },
    increaseMonth() {
      // Step 1: Choose slide left as the animation, and set display to false, so that when display is set to true again, it will animate
      this.currentSlide = "slide-left";
      this.$nextTick(() => {
        // Step 2: Increase the month
        const nextMonth = new Date(this.currentYear, this.currentMonth, 1);
        this.setWeek(nextMonth.getDate());
        this.setWeekMonth(nextMonth.getMonth());
        this.setWeekYear(nextMonth.getFullYear());

        // Fetch yearly appointment
        this.getYearlyAppointments(nextMonth.getFullYear());
      });
    },
    decreaseMonth() {
      // Step 1: Choose slide right as the animation, and set display to false, so that when display is set to true again, it will animate
      this.currentSlide = "slide-right";
      this.$nextTick(() => {
        // Step 2: Decrease the month
        const prevMonth = new Date(this.currentYear, this.currentMonth - 2, 1);
        this.setWeek(prevMonth.getDate());
        this.setWeekMonth(prevMonth.getMonth());
        this.setWeekYear(prevMonth.getFullYear());

        // Fetch yearly appointment
        this.getYearlyAppointments(prevMonth.getFullYear());
      });
    }
  },
  created() {
    this.getYearlyAppointments(new Date().getFullYear());
  }
};
</script>

<style scoped>
table {
  overflow: hidden;
  font-size: 14px;
}

.day-view-head .head tr th {
  font-size: 12px;
}

.mothly-view-calc tbody tr:first-of-type td {
  border-top: 1px solid #ccc;
}

/* .small-month-header {
  position: fixed;
  z-index: 7;
  top: 100px;
  right: 24px;
  background-color: #f8f8f8;
  text-transform: capitalize;
} */

th {
  padding-bottom: 12px;
}

/* stage 2. Entered */
.slide-right-enter-active {
  animation: slide-in-right 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-right-leave-active {
  animation: slide-out-right 0.2s ease-in-out forwards;
}

.slide-right-move {
  transition: transform 0.2s ease-in-out;
}

.slide-left-enter-active {
  animation: slide-in-left 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-left-leave-active {
  animation: slide-out-left 0.2s ease-in-out forwards;
}

.slide-left-move {
  transition: transform 0.2s ease-in-out;
}

@keyframes slide-in-right {
  from {
    transform: translateX(-20%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-right {
  from {
    transform: translateX(0px);
    opacity: 1;
  }

  to {
    transform: translateX(20%);
    opacity: 0;
  }
}

@keyframes slide-in-left {
  from {
    transform: translateX(20%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-left {
  from {
    transform: translateX(0px);
    opacity: 1;
  }

  to {
    transform: translateX(-20%);
    opacity: 0;
  }
}
</style>
